/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamExamlangidImportExamItemGrid200,
  GetApiV1ExamExamlangidImportExamItemGrid400,
  GetApiV1ExamExamlangidImportExamItemGrid401,
  GetApiV1ExamExamlangidImportExamItemGrid500,
  GetApiV1ExamExamlangidImportExamItemGridPathParams,
  GetApiV1ExamExamlangidImportExamItemGridQueryParams,
  GetApiV1ExamExamlangidImportExamItemGridQueryResponse,
} from "../../types/examEvaluationController/GetApiV1ExamExamlangidImportExamItemGrid.ts";
import { importExamItemGridItemRepositoryResponsePaginatedResponseSchema } from "../importExamItemGridItemRepositoryResponsePaginatedResponseSchema.ts";

export const getApiV1ExamExamlangidImportExamItemGridPathParamsSchema =
  z.object({
    examLangId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ExamExamlangidImportExamItemGridPathParams>;

export const getApiV1ExamExamlangidImportExamItemGridQueryParamsSchema = z
  .object({
    CompanyId: z.optional(z.coerce.number().int()),
    CultureInfo: z.optional(z.string()),
    AuthorId: z.optional(z.coerce.number().int()),
    DisciplineId: z.optional(z.coerce.number().int()),
    ComponentType: z.optional(z.coerce.number().int()),
    StartDate: z.optional(z.string()),
    EndDate: z.optional(z.string()),
    PageNumber: z.optional(z.coerce.number().int()),
    PageSize: z.optional(z.coerce.number().int()),
    SortField: z.optional(z.string()),
    SortDirection: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1ExamExamlangidImportExamItemGridQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamExamlangidImportExamItemGrid200Schema = z.lazy(
  () => importExamItemGridItemRepositoryResponsePaginatedResponseSchema,
) as unknown as ToZod<GetApiV1ExamExamlangidImportExamItemGrid200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamExamlangidImportExamItemGrid400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamlangidImportExamItemGrid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamExamlangidImportExamItemGrid401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamlangidImportExamItemGrid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamExamlangidImportExamItemGrid500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamlangidImportExamItemGrid500>;

export const getApiV1ExamExamlangidImportExamItemGridQueryResponseSchema =
  z.lazy(
    () => getApiV1ExamExamlangidImportExamItemGrid200Schema,
  ) as unknown as ToZod<GetApiV1ExamExamlangidImportExamItemGridQueryResponse>;
